export default __webpack_public_path__ + "images/online-payment/master-card.svg?f445da111d92a6cda9b402411fdee8a476e7eb4d9c774f7f0ed0eca8cd13dba9";